export const USER_DETAIL_ENDPOINT = '/user/details';
export const USER_UPDATE_ENDPOINT = '/user/update';
